// Credit to https://codepen.io/seoh/pen/PPZYQy for the general functionality

import React from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";

const formattedSeconds = (sec) => Math.floor(sec / 60) + ":" + ("0" + (sec % 60)).slice(-2);

class Stopwatch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      secondsElapsed: 0,
      laps: [],
      lastClearedIncrementer: null,
    };
    this.incrementer = null;
  }

  componentDidMount() {
    const { tickOnMount } = this.props;
    if (tickOnMount) {
      this.handleStartClick();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { onChange } = this.props;
    const { secondsElapsed } = this.state;
    if (prevState.secondsElapsed !== secondsElapsed) {
      onChange(secondsElapsed);
    }
  }

  componentWillUnmount() {
    this.handleStopClick();
  }

  handleStartClick() {
    const start = Date.now();
    this.incrementer = setInterval(() => {
      // below can't be used based changes below...will have to be re-think if needed
      // if(!this.props.paused)
      this.setState({ secondsElapsed: Math.floor((Date.now() - start) / 1000) });
    }, 1000);

    if (this.props.onStarted) this.props.onStarted();
  }

  handleStopClick() {
    clearInterval(this.incrementer);
    this.setState({
      lastClearedIncrementer: this.incrementer,
    });
    if (this.props.onStopped) this.props.onStopped();
  }

  render() {
    const { className, style } = this.props;
    return (
      <div className={className || undefined} style={{ textAlign: "center", width: "100%", ...style }}>
        <h1
          style={{
            fontWeight: 500,
            margin: 0,
            fontFamily: "var(--font-family)",
            color: "white",
            fontSize: "16px",
          }}
        >
          {this.props.label}
          {formattedSeconds(this.state.secondsElapsed)}
        </h1>

        {this.props.hideStopStart ||
          (this.state.secondsElapsed === 0 || this.incrementer === this.state.lastClearedIncrementer ? (
            <Button
              onClick={this.handleStartClick.bind(this)}
              className="m-t-10 save"
              style={{ width: "100%", float: "unset" }}
            >
              Resume
            </Button>
          ) : (
            <Button
              onClick={this.handleStopClick.bind(this)}
              className="m-t-10 save"
              style={{ width: "100%", float: "unset" }}
            >
              Pause
            </Button>
          ))}
      </div>
    );
  }
}

Stopwatch.defaultProps = {
  tickOnMount: true,
  whiteFont: false,
  paused: false,
};

Stopwatch.propTypes = {
  onStarted: PropTypes.func,
  onStopped: PropTypes.func,
  hideStopStart: PropTypes.bool,
  tickOnMount: PropTypes.bool,
  whiteFont: PropTypes.bool,
  className: PropTypes.string,
  onChange: PropTypes.func,
  paused: PropTypes.bool,
  label: PropTypes.string,
  style: PropTypes.object,
};

export default Stopwatch;
